import { render, staticRenderFns } from "./home-button.vue?vue&type=template&id=aecb3026&scoped=true"
import script from "./home-button.vue?vue&type=script&lang=js"
export * from "./home-button.vue?vue&type=script&lang=js"
import style0 from "./home-button.vue?vue&type=style&index=0&id=aecb3026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecb3026",
  null
  
)

export default component.exports